export default __webpack_public_path__ + "static/media/frog.551ccaea.svg";